import { createRoot } from "react-dom/client";

import { Root } from "components/root";
import { initFullstory, initSentry } from "utils";

import { initializeTracing } from "./utils/tracing-instrumentations";

initSentry();
initializeTracing();
initFullstory();

(async () => {
  const container = document.getElementById("app");
  if (!container) {
    console.error("no app element");
    return;
  }

  const root = createRoot(container);
  root.render(<Root />);
})();
